import taskApi from "~/api/task";
import Navigator from "~/mixins/navigator/navigator";
import taskTemplateApi from "~/api/task_template";
import NotificationsManager from "../../../../mixins/notifications/notifications_manager";

const getInitialEditPageData = ({ state, commit }) => {
  taskApi.getInitialEditPageData(state.task?.id)
    .then((response) => {
      commit("SET_DEPARTMENTS", response.data.departments);
      commit("SET_CATEGORIES", response.data.categories);
      commit("SET_PRODUCT_LABELS", response.data.productLabels);
      commit("SET_USERS", response.data.users);
      commit("SET_TYPES", response.data.types);
      // commit("SET_TYPE", response.data.type);
      commit("SET_TEMPLATES", response.data.templates.data);
    });
};

const getInitialCreatePageData = ({ state, commit }) => {
  taskApi.getInitialCreatePageData(state.category)
    .then((response) => {
      commit("SET_DEPARTMENTS", response.data.departments);
      commit("SET_CATEGORIES", response.data.categories);
      commit("SET_PRODUCT_LABELS", response.data.productLabels);
      commit("SET_USERS", response.data.users);
      commit("SET_TYPES", response.data.types);
      // commit("SET_TYPE", response.data.type);
      commit("SET_TEMPLATES", response.data.templates.data);
    });
};

const fillTaskState = ({ state, commit }) => {
  if (!("id" in state.task)) return Promise.resolve();
  return taskApi.getById(state.task.id).then((response) => {
    const taskModel = response.data;
    commit("FILL_TASK_BY_MODEL", taskModel);
  });
};

const saveTask = ({ state, getters }, redirect) => {
  if (!state.task) return;
  state.loading = true;
  if (getters.isEditing) {
    taskApi.update(state.task).then((response) => {
      NotificationsManager.success(response);
      if (redirect) {
        Navigator.navigatePath(redirect);
      } else {
        Navigator.back();
      }
    }).catch((error) => {
      NotificationsManager.error(error);
      state.loading = false;
    });
  } else {
    taskApi.store(state.task).then((response) => {
      NotificationsManager.success(response);
      if (redirect) {
        Navigator.navigatePath(redirect);
      } else {
        Navigator.back();
      }
    }).catch((error) => {
      NotificationsManager.error(error);
      state.loading = false;
    });
  }
};

const reloadTemplates = ({ state, commit }) => {
  taskTemplateApi.getByCategory(state.task.category_id, ["users", "departments", "product_labels"])
    .then((response) => {
      commit("SET_TEMPLATES", response.data);
    });
};

export default {
  saveTask,
  fillTaskState,
  getInitialEditPageData,
  getInitialCreatePageData,
  reloadTemplates,
};
